/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./viewDetails.vue?vue&type=template&id=2e42c254&scoped=true"
import script from "./viewDetails.vue?vue&type=script&lang=js"
export * from "./viewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42c254",
  null
  
)

export default component.exports